<template>
  <div class="chartType-setting"  v-if='boxData.judgeBox' :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex, }" @mousedown="stopDocument($event)">
    <div class="header" @mousedown="moveStart($event, true)" @mousemove="moveArea($event)" @mouseup="saveMoveState($event)" :style="{'cursor': 'move'}">
      <span>选择图表样式</span>
      <i @click="close" class="icon-popup-close"></i>
    </div>
    <switchChartType :chartFrom="chartFrom" :dataMsg="dataMsg" :showMark="false"></switchChartType>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import switchChartType from './content/switchChartType'
import popup from '../mixins/popup'
export default {
  mixins: [popup],
  data() {
    return {
      chartFrom: 'chartType',
      boxData  : {
        judgeBox : false, // 控制盒子开启关闭
        Zindex   : 0,     // 盒子层级
        data     : null,  // 盒子数据
        moveoks  : false, // 拖动判读啊数据
        oldMove  : {      // 计算移动增量
          x : 0,
          y : 0
        },
        fix : {           // 弹窗位置
          x : 0,
          y : 0
        }
      },
    }
  },
  props: ['dataMsg', 'boxDatas'],
  computed: {
    ...mapGetters([
      'TOOL',
      'TopNav_Size',
    ])
  },
  watch : {
    'boxDatas.firstDatas' : function(val, oldval){ // 判断打开关闭
      let num = Array.indexOf(this.boxDatas.firstDatas, 'switch_Chart');
      this.boxData.judgeBox = num < 0 ? false : true; // 判断是否打开

      if(this.TOOL && this.boxData.judgeBox){ // 打开的操作
        this.boxData.data = this.dataMsg.switch_Chart;
        this.boxData.Zindex = (this.dataMsg.length + 1)*5;
        this.boxData.fix.x = this.dataMsg.switch_Chart.posx + 28;
        this.boxData.fix.y = this.dataMsg.switch_Chart.posy + 28;
      }
    }
  },
  components: {
    switchChartType
  },
  mounted() {
    this.$bus.on('Document_mousemove_vue',(event) => {
      let e = event ? event: window.event;
      if(this.boxData.moveoks) {
        this.moveArea(e);
        return false;
      }
    });
    this.$bus.on('Document_mouseup_vue',(event) => {
      let e = event ? event: window.event;
      if(this.boxData.moveoks) {
        this.saveMoveState(e);
        return false;
      }
    });
  },
  methods: {
    close() {
      //FeaturesPop_close_vue
      this.$bus.emit('FeaturesPop_close_vue',{
				name : 'switch_Chart',
				type : 1
			});
    },
    stopDocument(e){      // 防止事件冒泡
      e.stopPropagation();
      e.preventDefault();
    },
  }
}
</script>

<style lang="scss" scoped>
.chartType-setting {
  position: fixed;
  top: 0;
  left: 0;
  width: 252px;
  height: 137px;
  z-index: 35;
  background: #fff;
  font-family: 'Microsoft YaHei';
  font-size: 14px;
  color: #474261;
  overflow: hidden;
  box-shadow: 0px 0px 4px 0px
		rgba(54, 76, 204, 0.4);
	border-radius: 4px;
  box-sizing: border-box;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px 0 15px;
    height: 28px;
    background-color: #d8dee9;
    span {
      color: #474261;
    }
    i {
      display: inline-block;
      width: 12px;
      height: 12px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/chartType.vue